import { Outlet } from 'react-router-dom';
import { HotelLayout } from '@/components/hotel/HotelLayout';
import { HotelSubscriptionGate } from '@/components/hotel/HotelSubscriptionGate';
import { useAuth } from '@/hooks/useAuth';

const RouteFallback = () => (
  <div className="flex min-h-[40vh] items-center justify-center text-sm text-vesta-navy/65">
    Loading…
  </div>
);

/**
 * Single persistent hotel chrome (sidebar + page transitions).
 * App pages render inside the hotel shell.
 */
export function HotelAppShell() {
  const { loading } = useAuth();

  if (loading) {
    return <RouteFallback />;
  }

  return (
    <HotelLayout>
      <HotelSubscriptionGate>
        <Outlet />
      </HotelSubscriptionGate>
    </HotelLayout>
  );
}

export default HotelAppShell;
